import { ObjectRefSelectorStore } from "src/components/ObjectRefSelector/ObjectRefSelectorStore";
import { ZAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { ZAttribute } from "src/types/ZAttribute";
import { z } from "zod";
import { zUid } from "src/types/zUid";

export const zObjectRefSelector = z.object({
  editor: z.literal("ObectRefSelector"),
  multiple: z.boolean().optional(),
  labelAtts: zUid.array().nullish(),
  isCreateButtonAvailable: z.boolean().optional(),
  multipleBlockers: zUid.array().optional(),
  useModal: z.boolean().optional(),
});
export type ZObjectRefSelector = z.infer<typeof zObjectRefSelector>;

export const makeObjectRefSelectorProps = (
  attribute: ZAttribute,
  component: ZObjectRefSelector,
  labelsData?: ZAttrLabelsData,
  objectName?: string,
) => ({
  store: new ObjectRefSelectorStore(attribute, labelsData),
  component,
  objectName,
});
